import React from "react";
import SectionTitle from "../Typography/SectionTitle";
import { APP_COLORS, ASSETS_PATH } from "../../utils/constants";
import { Box, Grid } from "@mui/material";

export default function SectionWithImg({
  children,
  title,
  id,
  isReversed,
  img,
  colored,
  centered,
}) {
  return (
    <Box id={id} className="container-fluid">
      <Grid
        container
        sx={{
          height: { xs: "auto", lg: "40rem" },
          overflow: "hidden",
          flexDirection: { xs: "column", md: isReversed && "row-reverse" },
        }}
      >
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            color: APP_COLORS.FONT,
            backgroundColor: colored && APP_COLORS.SECONDARY_BACKGROUND,
            px: { xs: "1rem", lg: "19rem" },
            pl: { xs: "1rem", lg: centered ? "19rem" : "8rem" },
            py: { xs: "50px", lg: "0" },
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Box>
            <SectionTitle title={title} />
            {children}
          </Box>
        </Grid>
        <Grid
          sx={{ backgroundColor: !colored && APP_COLORS.SECONDARY_BACKGROUND }}
          size={{ xs: 12, md: 4 }}
        >
          <img src={ASSETS_PATH + img} alt="craft" style={{ width: "100%" }} />
        </Grid>
      </Grid>
    </Box>
  );
}
